import { useEffect, useState } from "react"

import classes from './RadioField.module.css'
import RadioButton from "./RadioButton"
import { useCanEdit, useUserTabEditPermissionDisabled, useCanEditArchived } from "../../../lib/usersPermissions"
import { checkIfStringCanBeConvvertedToNumber } from "../../../lib/script"



const RadioField = ({fields, legend, name, defaultChecked, identifier, action, normalSize, isDisable, justDisplay, redFlag, blockOption, apiDisabled, showApiLoader}) => {
    // let masterDisable = useCanEdit()
    let editArchivedDisabled = useCanEditArchived()
    let userPermissionDisabled = useUserTabEditPermissionDisabled(identifier?.permissionType ? identifier?.permissionType : identifier?.type) 

    const [isChecked, setIsChecked] = useState(null)


    const changeHandler = (event) => {
        if (!userPermissionDisabled) { // check for user permission first
            setIsChecked(event.target.value)        

            let item = fields.find(item => item.value == event.target.value)

            if (action) {
                action({
                    // value: event.target.value,
                    data: {
                        value: checkIfStringCanBeConvvertedToNumber(event.target.value) 
                    },
                    identifier: identifier,
                    option: {
                        label: item?.label,
                        value: checkIfStringCanBeConvvertedToNumber(event.target.value)
                    }
                })
            }
        } 
        
    }

    function clickHandler(event) {
        if (event.target.value != undefined) {
            if (event.target.checked && event.target.value == defaultChecked) {
                setIsChecked(null)

                if (action) {
                action({
                        data: {
                            value: null 
                        },
                        identifier: identifier,
                    })
                }
            }
        }   
    }


    useEffect(() => {
        setIsChecked(defaultChecked)        
    }, [defaultChecked])


    return <>
        {fields && <div className={`${classes.container} ${normalSize ? classes.normal_size : ''}`}>
            {legend && (
                <div className={classes.legend}>
                    <span>{legend}</span>
                    {showApiLoader && apiDisabled ? <span className="loader dark field_label_loader" /> : null}
                </div>
            )}
            {/* {legend && <legend>{legend}</legend>} */}
            {fields.map(item => (
                <RadioButton key={item.value} item={item} checked={item.value == isChecked} clickHandler={clickHandler} changeHandler={changeHandler} name={name + (identifier?.type_id ?? '')} isDisable={isDisable || editArchivedDisabled || userPermissionDisabled || apiDisabled} justDisplay={justDisplay} redFlag={redFlag} isBlocked={blockOption}/>
            ))}    
        </div>}
    </>
}

export default RadioField